import * as React from 'react';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from "@mui/material/Box";
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import CADService from "../../services/CADService";
import AppUiDialogTitle from "../AppUiComponents/AppUiDialogTitle";
import DriveService from "../../services/DriveService";
import {FormControl, FormLabel, FormControlLabel, RadioGroup, Radio} from "@mui/material";
import { useState} from "react";
import {COMMANDS} from "./commandConst";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        minWidth: "40vw"
    }
}));


function FileCADDialog(props) {
    const {open, setOpen, row} = props;
    const [value, setCommand] = useState('');
    const {CurrentDrive, changeCurrentDrive, changeDeleteKey} = useDrive();
    const {addNotification} = useNotification();
    const handleClose = () => {
        setOpen(false);
    };

    const submit = async () => {
        const {parent} = CurrentDrive;
        const path = parent && parent !== "" && parent !== "/" ? parent + "/" + row.Key : row.Key;

        if (value && value !== ''){
            var params;

            switch(value) {
                case COMMANDS.CLEAN:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path
                    }
                    break;
                case COMMANDS.CENTERING:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path
                    }
                    break;
                case COMMANDS.SOLIDIFY:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path,
                        rot_x: 0,
                        rot_y: 0,
                        rot_z: 0
                    }
                    break;
                case COMMANDS.WALLS:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path,
                        rot_x: 0,
                        rot_y: 0,
                        rot_z: 0
                    }
                    break;
                case COMMANDS.DECIMATE:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path,
                        ratio: 0.5
                    }
                    break;
                case COMMANDS.INFLATE:
                    params = {
                        command: value,
                        files_in: [],
                        channel: "DRIVE",
                        path: path,
                        ratio: 0.5
                    }
                    break;
                default:
                    params = undefined;
                    break;
            } 

            await CADService.create(params);
            addNotification({type: "success", message: "CAD operation initiated successfully, resulted file will be saved to the folder once finished!"});
        }

        const drive = await DriveService.getFileTree(parent);
        changeCurrentDrive({parent, drive});
        handleClose();
    }

    const handleChange = event => {
        // console.log(event.currentTarget.value)
        setCommand(event.currentTarget.value)
    }
    return (
        <div>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="file-cad-dialog-title"
                open={open}
            >
                <AppUiDialogTitle id="file-cad-operations-title" onClose={handleClose}>
                    {row.type.charAt(0).toUpperCase() + row.type.slice(1)} CAD Operations
                </AppUiDialogTitle>
                <DialogContent dividers>
                    <Box noValidate sx={{mt: 1}}>
                        <FormControl>
                            <FormLabel id='cad-group-label' style={{color: "#8c3b61"}}>
                                Select the CAD Operation to Run
                            </FormLabel>
                            <RadioGroup name='cad-commands' area-aria-labelledby='cad-group-label' value={value} onChange={handleChange}>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Clean' value='clean'/>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Center' value='centering'/>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Solidify' value='solidify'/>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Inflate' value='inflate'/>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Decimate' value='decimate'/>
                                <FormControlLabel control={<Radio size='small' style={{color: "#8c3b61"}}/>} label='Walls' value='walls'/>
                            </RadioGroup>
                        </FormControl>
                       
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={submit}
                            type="submit">
                        Submit
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

FileCADDialog.propTypes = {}
export default FileCADDialog;